import { render, staticRenderFns } from "./AstroCalendarNoteCreate.vue?vue&type=template&id=0cd33527&scoped=true&"
import script from "./AstroCalendarNoteCreate.vue?vue&type=script&lang=js&"
export * from "./AstroCalendarNoteCreate.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendarNoteCreate.vue?vue&type=style&index=0&id=0cd33527&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd33527",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDatePicker,VDialog,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd33527')) {
      api.createRecord('0cd33527', component.options)
    } else {
      api.reload('0cd33527', component.options)
    }
    module.hot.accept("./AstroCalendarNoteCreate.vue?vue&type=template&id=0cd33527&scoped=true&", function () {
      api.rerender('0cd33527', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/共時曆/AstroCalendarNoteCreate.vue"
export default component.exports